/**
 * NOTE: NSAI-5822 — how far ahead of the sidebar's scrollport a list fetches
 * its next page. It used to be 0: the sentinel had to be scrolled fully into
 * view before anything happened, which made "does it paginate?" a question
 * about exact pixel geometry — the sidebar's scrollport was oversized by the
 * height of the account footer, and correcting that was enough to leave the
 * sentinel a few pixels short of ever appearing. Fetching a screenful early
 * also means the next page is usually there by the time the user reaches the
 * end of the list.
 */
export const SIDEBAR_INFINITE_SCROLL_ROOT_MARGIN = "200px";
